import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles.css';
import { useHabits } from "../contexts/HabitsContext";
import { useUsers } from "../contexts/UsersContext";

export default function Habits({ apiUrl, isAdmin }) {
  const [newHabitUserId, setNewHabitUserId] = useState('');
  const [newHabitDescription, setNewHabitDescription] = useState('');
  const [newHabitPointDescription, setNewHabitPointDescription] = useState('');
  const { habits, setHabits } = useHabits();
  const { users, setUsers } = useUsers();


  const handleCreateHabit = (habitUserId, habitDescription, habitPointDescription) => {
    const createUrl = `${apiUrl}/habits`;
    const newHabit = { description: habitDescription, user_id: habitUserId, point_description: habitPointDescription };

    axios
      .post(createUrl, newHabit, { withCredentials: true })
      .then((response) => {
        console.log(`Habit '${habitDescription}' created successfully.`);
        setHabits((prevHabits) => [...prevHabits, response.data]);
        setNewHabitUserId('');
        setNewHabitDescription('');
        setNewHabitPointDescription('');
      })
      .catch((error) => {
        console.error(`Error creating habit '${habitDescription}:`, error);
        alert('Failed to create the habit. Please try again.');
      });
  };

  const handleSubmitHabit = (event) => {
    event.preventDefault();
    if (!newHabitUserId || !newHabitDescription || !newHabitPointDescription) {
      alert('Please fill in all fields before submitting.');
      return;
    }
    handleCreateHabit(newHabitUserId, newHabitDescription, newHabitPointDescription);
  };

  const handleDeleteHabit = (habitId) => {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this habit?'
    );
    if (!confirmDelete) {
      return;
    }

    const deleteUrl = `${apiUrl}/habits/${habitId}`;
    axios
      .delete(deleteUrl, { withCredentials: true })
      .then(() => {
        console.log(`Habit with ID ${habitId} deleted successfully.`);
        setHabits(habits.filter((habit) => habit.id !== habitId));
      })
      .catch((error) => {
        console.error(`Error deleting habit with ID ${habitId}:`, error);
        alert('Failed to delete the habit. Please try again.');
      });
  };

  const handleShowHabit = (habitId) => {
    setHabits((prevHabits) =>
      prevHabits.map((habit) =>
        habit.id === habitId ? { ...habit, is_hidden: false } : habit
      )
    );
  
    const patchUrl = `${apiUrl}/habits/${habitId}/show`;
    axios
      .patch(patchUrl, { withCredentials: true })
      .then(() => {
        console.log(`Habit with ID ${habitId} shown successfully.`);
      })
      .catch((error) => {
        console.error(`Error showing habit with ID ${habitId}:`, error);
        alert('Failed to show the habit. Please try again.');
  
        // Revert change if API request fails
        setHabits((prevHabits) =>
          prevHabits.map((habit) =>
            habit.id === habitId ? { ...habit, is_hidden: true } : habit
          )
        );
      });
  };
  
  const handleHideHabit = (habitId) => {
    setHabits((prevHabits) =>
      prevHabits.map((habit) =>
        habit.id === habitId ? { ...habit, is_hidden: true } : habit
      )
    );
  
    const patchUrl = `${apiUrl}/habits/${habitId}/hide`;
    axios
      .patch(patchUrl, { withCredentials: true })
      .then(() => {
        console.log(`Habit with ID ${habitId} hidden successfully.`);
      })
      .catch((error) => {
        console.error(`Error hiding habit with ID ${habitId}:`, error);
        alert('Failed to hide the habit. Please try again.');
  
        // Revert change if API request fails
        setHabits((prevHabits) =>
          prevHabits.map((habit) =>
            habit.id === habitId ? { ...habit, is_hidden: false } : habit
          )
        );
      });
  };
  
  const findUserById = (userId) => {
    return users.find((u) => u.id === userId);
  };

  return isAdmin ? (
    <div className="habits-container">
      <div
        id="habitsTable"
        style={{ display: habits.length === 0 ? 'none' : '' }}
      >
        <table className="custom-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Description</th>
              <th>Points</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {habits.map((habit) => (
              <tr key={habit.id}>
                <td>{habit.id}</td>
                <td>{findUserById(habit.user_id)?.name}</td>
                <td>{habit.description}</td>
                <td>{habit.point_description}</td>
                <td>
                  <button
                    className="action-button"
                    onClick={() => handleDeleteHabit(habit.id)}
                  >
                    Delete
                  </button>
                  {habit.is_hidden ? (
                    <button
                      className="action-button"
                      onClick={() => handleShowHabit(habit.id)}>
                      Show
                    </button>
                  ) : (
                    <button
                      className="action-button"
                      onClick={() => handleHideHabit(habit.id)}>
                      Hide
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ display: habits.length === 0 ? '' : 'none' }}>
        <p>There are no habits. Use the form below to create one.</p>
      </div>
      <form className="habit-form" onSubmit={handleSubmitHabit}>
        <h3>Create a New Habit</h3>
        <div className="form-group">
          <label htmlFor="user">User:</label>
          <select
            id="user"
            value={newHabitUserId}
            onChange={(e) => setNewHabitUserId(e.target.value)}
          >
            <option value="">Select a user</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="description">Description:</label>
          <input
            type="text"
            id="description"
            value={newHabitDescription}
            onChange={(e) => setNewHabitDescription(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="pointDescription">Point Description:</label>
          <input
            id="pointDescription"
            value={newHabitPointDescription}
            onChange={(e) => setNewHabitPointDescription(e.target.value)}
          />
        </div>
        <button type="submit" className="action-button">
          Create Habit
        </button>
      </form>
    </div>
  ) : (
    ''
  );
}
